import React from "react";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableCell } from "@mui/material";

const TransactionHead = () => {
  return (
    <TableHead sx={{ backgroundColor: "red" }}>
      <TableRow>
        <TableCell
        sx={{
            position: "sticky",
            left: 0,
            zIndex: 3,
            backgroundColor: "#56595b",
            color: "#fff",
            width: "4em",
          }}
          // sx={{ width: "4em", backgroundColor: "#56595b", color: "#ffffff" }}
        />
        <TableCell
          // sx={{
          //   width: "7em",
          //   textWrap: "nowrap",
          //   backgroundColor: "#56595b",
          //   color: "#ffffff",
          // }}
          sx={{
            position: "sticky",
            left: 56, // match data cell offset
            zIndex: 3,
            backgroundColor: "#56595b",
            color: "#fff",
            width: "7em",
            textWrap: "nowrap",
          }}
          align="left"
        >
          OrderId
        </TableCell>
        <TableCell
          // sx={{
          //   width: "10em",
          //   textWrap: "nowrap",
          //   backgroundColor: "#56595b",
          //   color: "#ffffff",
          // }}
          sx={{
            position: "sticky",
            left: 154,
            zIndex: 3,
            backgroundColor: "#56595b",
            color: "#fff",
            width: "10em",
            textWrap: "nowrap",
          }}
          align="center"
        >
          Type
        </TableCell>
        <TableCell
          // sx={{
          //   width: "10em",
          //   textWrap: "nowrap",
          //   backgroundColor: "#56595b",
          //   color: "#ffffff",
          // }}
          sx={{
            position: "sticky",
            left: 294,
            zIndex: 3,
            backgroundColor: "#56595b",
            color: "#fff",
            width: "10em",
            textWrap: "nowrap",
          }}

          align="center"
        >
          Status
        </TableCell>
        <TableCell
          sx={{ width: "12em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Order Time
        </TableCell>
        <TableCell
          sx={{ width: "12em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Served Time
        </TableCell>

        <TableCell
          sx={{ width: "8em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Vat
        </TableCell>
        <TableCell
          sx={{ width: "8em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total SD
        </TableCell>
        <TableCell
          sx={{ width: "10em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Service Charge
        </TableCell>
        <TableCell
          sx={{ width: "10em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Service Charge Vat
        </TableCell>
        <TableCell
          sx={{ width: "8em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Tips
        </TableCell>
        <TableCell
          sx={{ width: "8em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Credit
        </TableCell>
        <TableCell
          sx={{ width: "8em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          SubTotal
        </TableCell>
        <TableCell
          sx={{ width: "8em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Amount
        </TableCell>
        <TableCell
          sx={{ width: "8em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Refunded
        </TableCell>

        <TableCell
          sx={{ width: "10em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Platform Fees
        </TableCell>
        <TableCell
          sx={{ width: "10em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Processing Fees
        </TableCell>
        <TableCell
          sx={{ width: "10em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Capture Fees
        </TableCell>
        <TableCell
          sx={{ width: "12em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Authorization Fees
        </TableCell>

        <TableCell
          sx={{ width: "12em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Gateway Fees
        </TableCell>
        <TableCell
          sx={{ width: "12em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Assessment Fees
        </TableCell>
        <TableCell
          sx={{ width: "12em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Interchange Fees
        </TableCell>
        <TableCell
          sx={{ width: "12em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Withdrawal Fees
        </TableCell>
        <TableCell
          sx={{ width: "12em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Refund Fees
        </TableCell>

        <TableCell
          sx={{ width: "11em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Transaction Fees
        </TableCell>
        <TableCell
          sx={{ width: "12em", backgroundColor: "#56595b", color: "#ffffff" }}
          align="center"
        >
          Total Withdrawable Amount
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TransactionHead;
